import MidiEffect from '../MidiEffect.js';
import RackFlow from '../RackFlow.js';
import {getMidiEffect} from '../getMidiEffect.js';
import RackableEffect from '../../rack/RackableEffect.js';
import ConfigurableRack from '../../rack/ConfigurableRack.js';
import MacroMixin from '../../MacroMixin.js';
import {ChordEffect} from './ChordEffects.js';
import {VoiceEffect} from './ChordEffects.js';
import ChordProgression from './ChordProgression.js';
import Voicing from './Voicing.js';


export default class ChordsRack extends RackFlow(Voicing(ChordProgression(RackableEffect(ConfigurableRack(MacroMixin(MidiEffect)))))) {

    constructor(track) {
        super("Chords Rack", track, 8);
        this.initializeConfigurations(this.adjacencyLists);
        this.addChords();
        this.initializeChordParameters();
    }

    addChords() {
        this.addEffect(new ChordEffect(this, 1));
        this.addEffect(new ChordEffect(this, 2));
        this.addEffect(new ChordEffect(this, 3));
        this.addEffect(new ChordEffect(this, 4));
        this.addEffect(new ChordEffect(this, 5));
        this.addEffect(new ChordEffect(this, 6));
        this.addEffect(new ChordEffect(this, 7));
        this.addEffect(new ChordEffect(this, 0));
        this.addEffect(new VoiceEffect(this, 1));
        this.addEffect(new VoiceEffect(this, 3));
        this.addEffect(new VoiceEffect(this, 5));

        // I
        this.effects[0].x = 40;
        this.effects[0].y = 47;

        // II
        this.effects[1].x = 120;
        this.effects[1].y = 18;

        // III
        this.effects[2].x = 220;
        this.effects[2].y = 16;

        // IV
        this.effects[3].x = 303;
        this.effects[3].y = 43;

        // V
        this.effects[4].x = 244;
        this.effects[4].y = 76;

        // VI
        this.effects[5].x = 167;
        this.effects[5].y = 99;

        // VII
        this.effects[6].x = 91;
        this.effects[6].y = 86;

        // ALL
        this.effects[7].x = 21;
        this.effects[7].y = 145;

        // voice 1
        this.effects[8].x = 6;
        this.effects[8].y = 200;

        // voice 2
        this.effects[9].x = 61;
        this.effects[9].y = 200;

        // voice 3
        this.effects[10].x = 125;
        this.effects[10].y = 200;

        // by default ALL CHORDS play with the 1st, 3rd and 5th
        // hence, we connect the "All Chords" effect to these
        // VoiceEffects
        this.connectNodes(this.effects[7], this.effects[8]);
        this.connectNodes(this.effects[7], this.effects[9]);
        this.connectNodes(this.effects[7], this.effects[10]);
    }
    
    clear() {
        this.counter = 0;
        this.effects.forEach(
            e => e.clear());
        this.triggers = [];
    }

    get isRack() {
        return true;
    }

    clearCaching() {
        this.effects.forEach(
           e => {
               e.subGraph = undefined;
               e.effects = undefined;
            });
    }

    addEffect(effect) {
        super.addEffect(effect);

        this.clearCaching();
        effect.rack = this;
    }

    connectNodes(...args) {
        super.connectNodes(...args);
        this.clearCaching();
    }

    deleteEdge(...args) {
        super.deleteEdge(...args);
        this.clearCaching();
    }

    deleteEffect(...args) {
        super.deleteEffect(...args);
        this.clearCaching();
    }

    getJson() {
        return this.getRackJson();
    }

    fromJson(json, isCopy, x, isCopy2, isCopy3=isCopy) {
        this.adjacencyLists = {};
        this.initializeConfigurations(this.adjacencyLists, false);
        this.effects = [];
        this.loaded = false;
        let bulk = super.fromJson(json, isCopy);

        let {effects} = json;
        for (let i in effects) {
            let jsonEffect = effects[i];
            let effect = getMidiEffect(jsonEffect, this.track);
            bulk = {
                ... bulk,
                ... effect.fromJson(jsonEffect, isCopy3)
            };
            if (effect.id !== jsonEffect.id) {
                for (let config of json.configurations) {
                    let adj = config[jsonEffect.id];
                    config[effect.id] = adj;
                    delete config[jsonEffect.id];
                }
            }
            this.addEffect(effect, false);
            effect.x = jsonEffect._x || jsonEffect.x;
            effect.y = jsonEffect._y || jsonEffect.y;
        }

        this.fromRackJson(json, isCopy);
        this.loaded = true;
        return bulk;
    }
}

